export const API_KEY = "79a548bf4a2b96bfa211550c53033e37" 
export const IMG_URL = "https://image.tmdb.org/t/p/original"